/* eslint-disable @nx/enforce-module-boundaries */
'use client';
import { IconButton, Menu, MenuButton, MenuItem, MenuList, Portal, Scrollable, Spinner, Text, Heading, Wrap, WrapItem, Tooltip } from '@mybridge/ui';
import { Card } from '@mybridge/ui/card';
import { Box, HStack, Stack, Container, VStack } from '@mybridge/ui/layout';
import { useRouter } from 'next/router';
import { useEffect, useContext, useState, useMemo, useRef } from 'react';
import {
  PublicProfileContext,
  usePublicProfileContext,
} from 'v4/components/public-profile/context';
import Link from 'next/link';
import { PublicProfileNotFound } from '../404';
import Banner from '../banner';
import ProfileTabs from '../tabs';
import { Tab, TabList, Tabs, TabPanels, TabPanel } from '@mybridge/ui/tabs';
import { MyNetworkContext } from 'v4/components/network/context';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import ProfilePublicNetwork from '../networks';
import { MyPublicProfilePosts } from '../posts';
import { PublicProfilePhotos } from '../photos';
import { PublicProfileVideos } from '../videos';
import ProfileStickyHeader from 'v4/components/profile-sticky-header';
import RightProfileActionsPublic from '../banner/right-profile-actions';
import HandshakeUserModal from 'v4/components/network/handshake-user-modal';
import { useSelector } from 'react-redux';
import { NetworkListingNotFound } from '../../404';
import { isMobile } from 'react-device-detect';
import Head from 'next/head';
import { useDispatch } from 'react-redux';
import { getAllConnectionIDs } from 'v4/store/actions/connection.actions';
import { MyPublicProfileArticles } from '../articles';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import styles from '../banner/banner.module.scss'
import statusProfileStyles from 'v4/components/header/status-dropdown/statusProfile.module.scss';
import { DashboardMyCircle } from 'v4/snippets/dashboard/circle';
import { MyProfileNetworkSuggestionsCarousel } from 'v4/components/public-profile/suggestions-carousel';
import { MyProfileMyBioDropdown } from '../../my-bio-dropdown';
import { MyProfileIntroduction } from 'v4/components/public-profile/introduction';
import { MyProfileEditButtonsGroup } from 'v4/components/profile/edit-btn-group';
import { MyProfileViewsCount } from 'v4/components/profile/views-count';
import { MyProfileLink } from 'v4/components/profile/profile-link';
import { MyProfileVisibility } from 'v4/components/profile/visibility';
import { MyProfileAnalytics } from '../../analytics';
import { MyConnectionsBox } from 'v4/components/profile/my-connections';
import { Button } from '@chakra-ui/react';
import { MyProfileContext } from 'v4/components/profile/context';
import { AcceptNewIcon, HandShakeSimpleIcon, IgnoreNewIcon, ManageTestimonialIcon, ThreeDot } from '@mybridge/icons';
import { MyProfilePersonalInfo } from 'v4/components/public-profile/personal-info';
import { myBridgeData } from 'v4/components/header/status-dropdown/constant';
import { MainCopyrightsText } from 'v4/components/copyrights-text';
import { SearchSidebar } from 'v4/snippets/search/sidebar';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { getUserFullName } from 'v4/lib/commons';

export const ProfileLayout = ({ children, active }) => {
  const { query, asPath, pathname } = useRouter();
  const lastSyncTabRef = useRef();
  const [randomThreeMessages, setRandomThreeMessages] = useState([]);
  const dispatch = useDispatch();
  const slug = query?.slug?.[0] ?? {};
  const articles = query?.slug?.[1] ?? {};
  const publicProfileContext = usePublicProfileContext({ slug });
  const { loggedIn } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const [stickyActive, setStickyActive] = useState(false);
  const  { t } = useTranslator();
  const direction = useDirection();
  const {
    handshakeUser,
    handshakeLoading,
    isHandshaked,
    isHandshakeRequested,
    acceptInvitationLoading,
    acceptInvitation,
    getRequestedAndSenderUserInfoFromUser,
    pendingInvitations,
    rejectInvitation,
    rejectInvitationLoading,
    isFriend,
    setHandshakeSelectedUser,
    unfriendLoading,
    selectedUser,
    setSelectedUser,
    handshakeMessageDisc,
    handleHandshakeSendRevoke,
    revokeHandshakeLoading,
    filters = {},
  } = useContext(MyNetworkContext);
  const {
    jobPreferences,
    peopleSliderDisc,
  } = MyProfileContext ?? {};
  const {
    publicProfile,
    refetchPublicProfile,
    publicProfileLoading,
    userProfileInfo,
    publicActiveTab,
    setPublicActiveTab,
    refetchPublicArticles,
    publicArticles,
    connections,
    hasPersonalInfo,
    hasIntro,
    refetchConnections,
    mutualConnections,
    refetchMutualConnections,
    hasWebsite,
    hasInterestedIn,
    hasCauses,
    hasLinks,
    publicProfileFetching
  } = publicProfileContext ?? {};

  const tabs = useMemo(() => [
    'post',
    // ...(!isMobile ? ['about'] : []),
    'about',
    ...(publicArticles?.length > 0 ? ['articles'] : []),
    ...(isFriend?.(publicProfile) ? ['photos', 'videos'] : []),
    ...(isFriend?.(publicProfile) && publicProfile?.field_audience_visibility?.WHO_CAN_SEE_FRIENDS === 1 ? ['network'] : []),
  ], [isMobile, publicArticles?.length, isFriend, publicProfile]);

  useEffect(() => {
    if (slug?.length > 0) {
      refetchPublicProfile?.();
    }
  }, [slug, refetchPublicProfile]);


    const getUserSlug = () => {
      return userProfileInfo?.slug || userProfileInfo?.username || null;
    };
  
    const trackJPublicProfile = () => {
      const userSlug = getUserSlug();
      if (!userSlug) return;
  
      trackEvent(ANALYTICS_EVENTS.PublicProfile, userSlug, {
        page_path: asPath,
        track_section: pathname,
        device_type: isMobile ? 'mobile' : 'desktop',
        timestamp: new Date().toISOString()
      });
    };
  
    useEffect(() => {
      if (userProfileInfo) {
        trackJPublicProfile();
      }
    }, []);
  

  useEffect(() => {
    if (userProfileInfo?.id) {
      dispatch(getAllConnectionIDs?.());
      refetchPublicArticles?.()
    }
  }, [publicProfile]);

  // useEffect(() => {
  //   if (articles?.length) {
  //     const idx = tabs.indexOf(articles);
  //     if (idx !== -1) {
  //       setPublicActiveTab(idx);
  //     }
  //   }
  // }, [publicProfile, articles, tabs]);

  const handleProfileHandshake = (user) => {
    setHandshakeSelectedUser(user);
    handshakeMessageDisc?.onOpen();
  };


  useEffect(() => {
    function getRandomThree(arr) {
      const shuffled = arr.sort(() => 0.5 - Math.random());
      return shuffled.slice(0, 2);
    }

    setRandomThreeMessages(getRandomThree(myBridgeData));
  }, []);

  //  useEffect(() => {
  //   // Check for tab query parameter and set tab index directly
  //   if (query.tab === 'articles') {
  //     setPublicActiveTab(2); // Articles tab index
  //   } else if (query.tab === 'about') {
  //     setPublicActiveTab(1); // About tab index
  //   } else if (query.tab === 'photos') {
  //     setPublicActiveTab(3); // Photos tab index
  //   } else if (query.tab === 'videos') {
  //     setPublicActiveTab(4); // Videos tab index
  //   } else if (query.tab === 'network') {
  //     setPublicActiveTab(5); // Network tab index
  //   }
    
  //   // Also check URL path structure
  //   if (query?.slug?.[1] === 'articles') {
  //     setPublicActiveTab(2);
  //   } else if (query?.slug?.[1] === 'about') {
  //     setPublicActiveTab(1);
  //   } else if (query?.slug?.[1] === 'photos') {
  //     setPublicActiveTab(3);
  //   } else if (query?.slug?.[1] === 'videos') {
  //     setPublicActiveTab(4);
  //   } else if (query?.slug?.[1] === 'network') {
  //     setPublicActiveTab(5);
  //   }
  // }, [query]); // Only depend on query to avoid unnecessary re-renders


  useEffect(() => {
    const tabName = query.tab || query?.slug?.[1] || 'post';
    if (tabName && tabName !== lastSyncTabRef.current) {
      const idx = tabs.indexOf(tabName);
      if (idx !== -1) {
        lastSyncTabRef.current = tabName;
        setPublicActiveTab(idx);
      }
    }
  }, [query, tabs]);

  // if (publicProfileLoading || publicProfileFetching)
  if (!publicProfile && (publicProfileLoading || publicProfileFetching))
    return (
      <HStack justifyContent="center">
        <Spinner />
      </HStack>
    );

  // if (slug?.length > 0 && !publicProfileLoading && !publicProfileFetching && (!publicProfile?.id || !publicProfile?.is_visible))
  if (slug?.length > 0 && !publicProfileLoading && (!publicProfile?.id || !publicProfile?.is_visible))
    return (
      <HStack justifyContent="center">
        <PublicProfileNotFound />
      </HStack>
    );
  
  const pageTitle = [
    loggedIn && globalNotifCount ? `(${globalNotifCount})` : null,
    `${publicProfile?.first_name || ''} ${publicProfile?.last_name || ''}`.trim() || 'Profile',
    'myBridge'
  ].filter(Boolean).join(' | ');

  return (
    <>
      <PublicProfileContext.Provider value={publicProfileContext}>
        <Head>
          <title>{pageTitle}</title>
        </Head>

        <HStack
          flexDir={['column', 'column', 'row']}
          alignItems="flex-start"
          justifyContent="center"
          // spacing={0}
          w="100%"
          backgroundColor="rgb(255, 255, 255)"
        >
          {/* Left */}
          {!isMobile && (
            /* <Stack
              display={['none', 'none', 'flex']}
              // className={styles.left}
              // w={['90px', '90px', '280px']}
              pos="sticky"
              top="64px"
              spacing={2}
              // bg="white"
              // boxShadow="2px 0px 6px 0px #00000033"
              w="240px"
              // minH="100vh"
              borderBottom="1px solid #e0e0e094"
              height={'500px'}
              sx={{

                '@media (max-width: 1301px)': {
                  width: loggedIn?'80px':'270px',
                },
                '@media (max-width: 1182px)': {
                  width: loggedIn?'85px':'180px',
                },
              }}

            // overflowX={"hidden"}
            // overflowy={"auto"}
            > */
            <Stack
              display={['none', 'none', 'flex']}
              className={statusProfileStyles.left}
              pos="sticky"
              top="64px"
              spacing={2}
              borderBottom="1px solid #e0e0e094"
              height={'500px'}
            >
              {/* <Scrollable maxH="99vh" flex={1}> */}

              <Stack
                spacing={2}
                // w={['200px', '20px', '20px']}
                justifyContent="space-between"
                height="100%"
                align="stretch"
                h="calc(100vh - 0px)"
                // className={styles.paddingLeftSmall}
                backgroundColor="rgb(255, 255, 255)"
              // overflowY={"auto"}
              // overflowX={"hidden"}
              >
                <Stack spacing={2} align="stretch" h="100%" flex="1">
                 {loggedIn&&( <SiteShortcutLinks />)}
                  {!loggedIn&&(<SearchSidebar />)}
                  <Box className={styles.Network}>
                   {loggedIn&&<DashboardMyCircle h="300px" flex="1" />}
                  </Box>
                </Stack>
                {/* <ImportContacts /> */}
                {/* <MainCopyrightsText /> */}
              </Stack>
              {/* </Scrollable> */}
            </Stack>

          )}
          {/* center */}
          {(
            <Box width={isMobile?'100%':""} className={styles.centerZoom}>
              <Stack spacing={4} mt={[0, 2]}>
                {(
                  <>
                    <Card
                      variant="thinBorderedCard"
                      borderRadius="0"
                      position="relative"
                    >
                      {(
                        <Box
                          bgImage={
                            publicProfile?.profile_banner_pic &&
                              !publicProfile?.profile_banner_pic.includes(
                                'banner-placeholder1.png'
                              )
                              ? publicProfile?.profile_banner_pic
                              : '/images/defaultBanner.svg'
                          }
                         
                        ></Box>
                      )}

                      <Banner />
                      <Container w={isMobile?'100%':"100%"} maxW="none" p={0} zIndex="1" {...(direction === 'rtl' && !isMobile) ? {mr: 1} : (!isMobile ? {ml: 1} : {})}>
                        {peopleSliderDisc?.isOpen && (
                          <MyProfileNetworkSuggestionsCarousel />
                        )}

                        {!stickyActive && (
                          <ProfileTabs
                            active={active}
                            borderTop="1px solid #EFF3F4"
                            mt={3}
                            profile={publicProfile}
                            isArticle={articles?.length ? true : false}
                            publicActiveTab={publicActiveTab}
                            setPublicActiveTab={setPublicActiveTab}
                          />
                        )}
                      </Container>
                    </Card>
                    {!isMobile && <ProfileStickyHeader
                      profile={publicProfile}
                      tabsMenu={<ProfileTabs 
                        active={active}
                        profile={publicProfile}
                        isArticle={articles?.length ? true : false} 
                        publicActiveTab={publicActiveTab}
                        setPublicActiveTab={setPublicActiveTab}
                      
                      
                      />}
                      fromPrivate={true}
                      mt={-4}
                      isActive={(e) => setStickyActive(e)}
                      actions={<RightProfileActionsPublic noFollow />}
                    />}
                  </>
                )}
                <Container maxW="1270px" p={isMobile?0:0}>
                  {/* <Tabs index={publicActiveTab} onChange={(index) => setPublicActiveTab(index)}> */}
                  <Tabs isLazy index={publicActiveTab} onChange={(index) => setPublicActiveTab(index)}>
                    <TabPanels>
                      <TabPanel p={0}>
                        <MyPublicProfilePosts />
                      </TabPanel>
                      <TabPanel p={0}>
                        {children}
                      </TabPanel>
                      {publicArticles?.length>0 && (
                        <TabPanel p={0} mt={1}>
                          < MyPublicProfileArticles />
                        </TabPanel>
                      )}
                      {isFriend?.(publicProfile) && (
                        <TabPanel p={0}>
                          <PublicProfilePhotos
                            linkForVideos={() => {
                              const idx = tabs.indexOf('videos');
                              if (idx !== -1) setPublicActiveTab(idx);
                            }}
                          />
                        </TabPanel>
                      )}
                      {isFriend?.(publicProfile) && (
                        <TabPanel p={0}>
                          <PublicProfileVideos
                            linkForVideos={() => {
                              const idx = tabs.indexOf('photos');
                              if (idx !== -1) setPublicActiveTab(idx);
                            }}
                          />
                        </TabPanel>
                      )}
                      {isFriend?.(publicProfile) && publicProfile?.field_audience_visibility?.WHO_CAN_SEE_FRIENDS === 1 && (
                        <TabPanel p={0}>
                          <ProfilePublicNetwork />
                        </TabPanel>
                      )}
                    </TabPanels>
                  </Tabs>
                </Container>
              </Stack>
            </Box>
          )}

          {/* Right */}
          {!isMobile && (
            <Scrollable pos="sticky"
              top="70px"
              width={loggedIn?"":"350px"}
              maxH="90vh"
              className={loggedIn?styles.rightZoom:styles.rightSidePannel}
              sx={{
                '@media (max-width: 1024px)': {
                  display: 'none'
                },
              }}
              >

              <Stack
                spacing={0}
                // w={['100%', '300px', '350px']}
                borderTopRightRadius="10px"
                borderTopLeftRadius="10px"
              
                className={loggedIn?styles.rightZoom:styles.rightSidePannel}
              >
                {publicProfile?.profile_intro && (
                  <Card borderRadius="16px" mt={2} p={3} border="1px solid #E4E6EB" variant="thinBorderedCard">
                    <MyProfileIntroduction />
                  </Card>
                )}
                {hasWebsite || hasInterestedIn || hasCauses || hasLinks ? (
                  <Card borderRadius="16px"  mt={2} border="1px solid #E4E6EB" p={3} variant="thinBorderedCard">
                    <MyProfilePersonalInfo displayCard={true} />
                  </Card>
                ) : (
                  ''
                )}
                {isFriend?.(publicProfile) && (
                  <Card borderRadius="16px" mt={2} border="1px solid #E4E6EB" p={3} variant="thinBorderedCard">
                    <Text mb={3} fontSize="14px" color="#868585">
                      {t('publicProfile.giveOrAsk') || "Give or Ask"} {publicProfile?.display_name} {t('publicProfile.forTestimonial') || "for testimonial"}
                    </Text>
                    <Link href="/profile/testimonials">
                      <Button
                        leftIcon={<ManageTestimonialIcon />}
                        variant="secondary"
                        color="#868585"
                        size="lg"
                        maxW="fit-content"
                        borderRadius={65}
                      >
                        {t('publicProfile.manageTestimonial') || "Manage testimonial"}
                      </Button>
                    </Link>
                  </Card>
                )}
                {publicProfile?.id !== userProfileInfo?.id && (
                  <>
                    {!isFriend?.(publicProfile) && (
                      <Card borderRadius="16px" mt={2} border="1px solid #E4E6EB" p={3} variant="thinBorderedCard">
                        <Text mb={3} fontSize="14px" color="#868585">
                          {t('publicProfile.send') || "Send"} {publicProfile?.display_name} {t('publicProfile.handshakeSent') || "handshake request"}
                        </Text>

                        {isHandshaked?.(publicProfile) ? (
                          isHandshakeRequested(publicProfile) ? (
                            <Tooltip isDisabled={!publicProfile?.is_blocked} label="User is blocked">
                              <Button
                                variant="secondary"
                                borderRadius={"50px"}
                                color="#3D5A80"
                                maxW="fit-content"
                                /* cursor="pointer" */
                                cursor={publicProfile?.is_blocked ? "not-allowed" : "pointer"}
                                opacity={publicProfile?.is_blocked ? 0.5 : 1}
                                leftIcon={
                                  <HandShakeSimpleIcon
                                    width="20"
                                    height="20"
                                    color="rgb(179, 140, 140)"
                                  />
                                }
                                isLoading={revokeHandshakeLoading}
                                // onClick={() => handshakeUser(publicProfile)}
                                /* onClick={() => handleHandshakeSendRevoke(publicProfile)} */
                                onClick={publicProfile?.is_blocked ? undefined : () =>
                                  handleHandshakeSendRevoke(publicProfile)
                                }
                              >
                                {t('publicProfile.withdrawHandshake') || "Withdraw Handshake"}
                              </Button>
                            </Tooltip>
                          ) : (
                            <HStack justifyContent={"center"} >
                              <Button
                                variant="secondary"
                                borderRadius={"50px"}
                                flex={1}
                                color="#3D5A80"
                                isLoading={rejectInvitationLoading}
                                leftIcon={<IgnoreNewIcon />}
                                onClick={() => {
                                  if(pendingInvitations && publicProfile){
                                    const user = getRequestedAndSenderUserInfoFromUser(publicProfile, pendingInvitations)
                                    rejectInvitation(user)
                                  }
                                }}
                              >
                                {t('profileNetwork.ignore') || "Ignore"}
                              </Button>
                              <Button
                                variant="secondary"
                                borderRadius={"50px"}
                                color="#3D5A80"
                                flex={1}
                                isLoading={acceptInvitationLoading}
                                leftIcon={<AcceptNewIcon />}
                                type="button"
                                onClick={async (e) => {
                                  e?.preventDefault?.();
                                  if(pendingInvitations && publicProfile){
                                    const user = getRequestedAndSenderUserInfoFromUser(publicProfile, pendingInvitations);
                                    await acceptInvitation(user);
                                    refetchPublicProfile?.();
                                  }
                                }}
                              >
                                {t('profileNetwork.accept') || "Accept"}
                              </Button>
                            </HStack> 
                          )
                        ) : (
                          <ForceSignInWrapper>
                            <Tooltip isDisabled={!publicProfile?.is_blocked} label="User is blocked">
                              <Button
                                variant="secondary"
                                borderRadius={"50px"}
                                // border="1px solid #00000033 !important"
                                color="#3D5A80"
                                maxW="fit-content"
                                /* cursor="pointer" */
                                cursor={publicProfile?.is_blocked ? "not-allowed" : "pointer"}
                                opacity={publicProfile?.is_blocked ? 0.5 : 1}
                                leftIcon={
                                  <HandShakeSimpleIcon
                                    width="20"
                                    height="20"
                                    color="rgb(148, 176, 150)"
                                  />
                                }
                                isLoading={
                                  (unfriendLoading || handshakeLoading) &&
                                  selectedUser?.id === publicProfile?.id
                                }
                                // onClick={() => handshakeUser(publicProfile)}
                                /* onClick={() => handleProfileHandshake(publicProfile)} */
                                onClick={publicProfile?.is_blocked ? undefined : () => handleProfileHandshake(publicProfile)}
                              >
                                {t('publicProfile.handshake') || "Handshake"}
                              </Button>
                            </Tooltip>
                          </ForceSignInWrapper>
                        )}


                      </Card>
                    )}
                  </>
                )}
                {isFriend?.(publicProfile) && publicProfile?.field_audience_visibility?.WHO_CAN_SEE_FRIENDS===1 && mutualConnections?.length > 0 && (
                  <Card borderRadius="16px" mt={2} border="1px solid #E4E6EB" p={3} variant="thinBorderedCard">
                    <Heading
                      fontWeight="medium"
                      fontSize="20px"
                      color="brandPrimary.500"
                      mb={3}
                    >
                      {getUserFullName(publicProfile)}&apos;s {t('profile.connections') || "Connections"}
                    </Heading>
                    
                    <Box maxH="478px" overflowY="auto">
                      <Wrap spacing={2}>
                        {mutualConnections?.map((connection, index) => (
                            <WrapItem key={index} minW="150px" maxW="calc(50% - 4px)" w={'50%'}>
                              <MyNetworkUserCardBordered
                                user={connection}
                                showFollowers={false}
                                divider={false}
                              />
                            </WrapItem>
                          ))}
                      </Wrap>
                    </Box>
                  </Card>
                )}

                <Box mb={"10px"}>

                  {randomThreeMessages.map((content) => (
                    <Box
                      bg="#ECECEC"
                      boxShadow="0px 4px 4px 0px #00000040"
                      mt={4}

                      minH="175px"
                      border="1px solid #E4E6EB"
                      borderRadius={"16px"}
                    >
                      <Stack p={2}>
                        <Text color="#617898" fontSize="19px">
                          {t(content.headingKey) || content?.heading}
                        </Text>
                        <VStack>
                          <Text color="#5B5B5B" fontSize="15px">
                            {t(content.descriptionKey) || content?.description}
                          </Text>
                        </VStack>
                      </Stack>
                    </Box>
                  ))}


                  {!loggedIn &&
                    (<Box display={['none', 'none', 'block']} mt={'30px'}>
                      <MainCopyrightsText alignment="center" />
                    </Box>)}
                </Box>

                {loggedIn && connections?.pages?.[0]?.count > 0 ? (
                  <Box variant="thinBorderedCard" mt={3}>
                    <Heading
                      fontSize="20px"
                      color="brandPrimary.500"
                      fontWeight="600"
                    >
                      {publicProfile?.display_name}' {t('profile.connections') || "Connections"}
                    </Heading>
                    <HStack justifyContent="space-between" mb={3}>
                      <Text fontSize="sm">
                        {connections?.pages?.[0]?.count}{' '}
                        <>
                          {!mutualConnections?.count && (
                            <Box as="span">{t('profile.connections') || "Connections"}</Box>
                          )}
                        </>
                        <>
                          {mutualConnections?.count > 0 && (
                            <>({mutualConnections?.count} {t('publicProfile.sharedConnections') || "shared connections"})</>
                          )}
                        </>
                      </Text>

                      <Link href="#">{t('post.seeAll') || "See all"}</Link>
                    </HStack>

                    <Wrap spacing={4} m={1}>
                      {connections?.pages?.[0]?.results
                        ?.slice(0, 4)
                        ?.map((cu, i) => (
                          <WrapItem
                            key={i}
                            minW="160px"
                            maxW={['49%', '30%', '250px']}
                            flexGrow={['1', '1', 0]}
                            flexShrink={['1', '1', 0]}
                          >
                            <MyNetworkUserCardBordered
                              user={cu}
                              actions={
                                userProfileInfo?.id !== cu?.id ? (
                                  isFriend(cu) ? (
                                    <HStack justifyContent="center">
                                      <IconButton
                                        onClick={(e) => startChatSingle(cu)}
                                      >
                                        <ChatIcon width={20} height={20} />
                                      </IconButton>

                                      <MyNetworkCircleCardMenu user={cu} />
                                    </HStack>
                                  ) : (
                                    <HStack justifyContent="center">
                                      <Tooltip
                                        /* label={
                                          isHandshaked(cu)
                                            ? t('publicProfile.handshakeSent') || 'Handshake sent'
                                            : t('publicProfile.handshake') || 'Handshake'
                                        } */
                                        label={
                                          cu?.is_blocked
                                            ? 'User is blocked'
                                            : isHandshaked(cu)
                                            ? t('publicProfile.handshakeSent') || 'Handshake sent'
                                            : t('publicProfile.handshake') || 'Handshake'
                                        }
                                      >
                                        <IconButton
                                          /* onClick={(e) => {
                                            if (isHandshaked(cu)) return;
                                            setSelectedUser(cu);
                                            handshakeUser(cu);
                                          }} */
                                          onClick={(e) => {
                                            if (cu?.is_blocked || isHandshaked(cu)) return;
                                            setSelectedUser(cu);
                                            handshakeUser(cu);
                                          }}
                                          variant="secondary"
                                          isLoading={
                                            (unfriendLoading ||
                                              handshakeLoading) &&
                                            selectedUser?.id === cu?.id
                                          }
                                          /* isDisabled={isHandshaked(cu)} */
                                          isDisabled={!cu?.is_blocked && isHandshaked(cu)}
                                          cursor={cu?.is_blocked ? "not-allowed" : "pointer"}
                                          opacity={cu?.is_blocked ? 0.5 : 1}
                                        >
                                          <HandShakeSimpleIcon
                                            color={'rgb(148, 176, 150)'}
                                            width={20}
                                            height={20}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </HStack>
                                  )
                                ) : (
                                  <HStack justifyContent="center">
                                    <Link href="/profile/me">
                                      <IconButton>
                                        <Eye
                                          color="#9F9F9F"
                                          width="22"
                                          height="15"
                                        />
                                      </IconButton>
                                    </Link>
                                  </HStack>
                                )
                              }
                            />
                          </WrapItem>
                        ))}
                    </Wrap>

                  </Box>
                ) : (
                  ''
                )}
              </Stack>
            </Scrollable>

          )}

        </HStack>

        {handshakeMessageDisc?.isOpen && <HandshakeUserModal />}
      </PublicProfileContext.Provider>
    </>
  );

};

// <PublicProfileContext.Provider value={publicProfileContext}>
//   <Head>
//     <title>
//       {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''}{' '}
//       {`${publicProfile?.first_name} ${publicProfile?.last_name}`} |
//       myBridge
//     </title>
//   </Head>

//   <Tabs
//     defaultIndex={publicActiveTab}
//     index={publicActiveTab}
//     onChange={(index) => setPublicActiveTab(index)}
//   >
//     <Stack spacing={4}>
//       <Card>
//         {!isMobile && (
//           <Box
//             bgImage={
//               publicProfile?.profile_banner_pic &&
//                 !publicProfile?.profile_banner_pic.includes(
//                   'banner-placeholder1.png'
//                 )
//                 ? publicProfile?.profile_banner_pic
//                 : '/images/defaultBanner.svg'
//             }
//             className="bannerBGContainer"
//           ></Box>
//         )}

//         <Banner />
//         <Box h={4} />
//         <Container maxW="1220px" p={0} zIndex="1">
//           {!stickyActive ? (
//             <ProfileTabs
//               active={active}
//               profile={publicProfile}
//               isArticle={articles?.length ? true : false}
//             />
//           ) : (
//             <></>
//           )}
//         </Container>
//       </Card>
//       {!isMobile && (
//         <ProfileStickyHeader
//           profile={publicProfile}
//           tabsMenu={
//             <ProfileTabs
//               active={active}
//               profile={publicProfile}
//               isArticle={articles?.length ? true : false}
//             />
//           }
//           actions={<RightProfileActionsPublic noFollow />}
//           isActive={(e) => setStickyActive(e)}
//         />
//       )}
// <Container maxW="1220px" p={0}>
//   <TabPanels p="0">
//     <TabPanel p="0">
//       {publicActiveTab === 0 && <MyPublicProfilePosts />}
//     </TabPanel>
//     <TabPanel p={[2, 0]}>
//       {publicActiveTab === 1 && children}
//     </TabPanel>
//     <TabPanel p={[2, 0]}>
//       {publicActiveTab === 2 && <PublicProfilePhotos linkForVideos={() => setPublicActiveTab(3)} />}
//     </TabPanel>
//     <TabPanel p={[2, 0]}>
//       {publicActiveTab === 3 && <PublicProfileVideos linkForVideos={() => setPublicActiveTab(2)} />}
//     </TabPanel>
//     {publicArticles?.length && <TabPanel p="0">
//       {publicActiveTab === 4 && <MyPublicProfileArticles />}
//     </TabPanel>}
//     {isFriend?.(publicProfile) && (
//       <TabPanel p="0">
//         {loggedIn && (publicArticles?.length > 0 ? publicActiveTab === 5 : publicActiveTab === 4) ? (
//           <ProfilePublicNetwork />
//         ) : (
//           <HStack justifyContent="center">
//             <Stack alignItems="center" py="150px">
//               <NetworkListingNotFound />
//               <Text>Manage Invitations</Text>
//             </Stack>
//           </HStack>
//         )}
//       </TabPanel>
//     )}
//   </TabPanels>
// </Container>
//     </Stack>
//   </Tabs>

//   {handshakeMessageDisc?.isOpen && <HandshakeUserModal />}
// </PublicProfileContext.Provider>